<template>
    <div class=" wrap ">
        <div class="page">
            <h1 class="zzgray" v-html="page.title.rendered"></h1>
<div class="content" v-html="page.content.rendered"></div>
            </div>

            <Blocks :blocks="page.acf.zeile"></Blocks>
    <Foot v-if="page.acf.zeile"></Foot>
        </div>

</template>
<script>
    import store from '@/store'
    import Velocity from "velocity-animate";
    import Blocks from '@/components/Blocks/Blocks.vue'
    import Foot from '@/components/Footer.vue'
    export default {
        Velocity,
        store,
        data() {
            return {
                // page: []
            }
        },
        created: function () {
            document.body.classList.remove('nooverflow');
        },
        components: {Blocks, Foot},
        props: {page: Object},
        name: "Team",
        mounted() {
            document.body.classList.remove('nooverflow');
        },
        computed: {
            pages: () => store.state.pages,
        },
        methods: {}
    }
</script>
<style scoped lang="scss">
    .wrap {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .page {
            max-width: 1080px;
            /*margin-top: 50px;*/
            width: 100%;
          padding-bottom: 60px;
        }
        @include tablet {
             padding: 100px 20px 0;}
        position: relative;
        overflow: auto;
        padding-top: 112px;
        width: 100%;
        opacity: 1;
        background-color: #fff;

    } .content {
          min-height: 10px;
      }
</style>
